var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVistaFlexLogoMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 67,
    viewBox: "0 0 77 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4393,
    cy: 33.4393,
    r: 33.4393,
    fill: "#DCEFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4043 18.9307C12.4793 18.369 8.94698 18.0156 8.94698 18.0156C8.94698 18.0156 13.2565 28.0528 16.0125 34.4863C19.9148 43.5959 22.2335 48.9134 26.1228 58.0285C26.1228 58.0285 30.7556 48.2242 31.3184 47.0985C31.3184 47.0985 21.9858 44.2298 21.9858 36.5452C21.9858 27.3948 19.5439 20.4304 14.4043 18.9307Z",
    fill: "#0075FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1228 58.0285C26.1228 58.0285 30.7556 48.2242 31.3184 47.0985L26.8928 58.0285H26.1228Z",
    fill: "#0075FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1228 58.0285C26.1228 58.0285 30.7556 48.2242 31.3184 47.0985M26.1228 58.0285C22.2335 48.9134 19.9148 43.5959 16.0125 34.4863C13.2565 28.0528 8.94698 18.0156 8.94698 18.0156C8.94698 18.0156 12.4793 18.369 14.4043 18.9307C19.5439 20.4304 21.9858 27.3948 21.9858 36.5452C21.9858 44.2298 31.3184 47.0985 31.3184 47.0985M26.1228 58.0285H26.8928L31.3184 47.0985",
    stroke: "#0075FF",
    strokeWidth: 1.88391
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.472 18.9307C54.397 18.369 57.9294 18.0156 57.9294 18.0156C57.9294 18.0156 53.6199 28.0528 50.8638 34.4863C46.9615 43.5959 45.028 49.0514 41.1387 58.1665C39.9775 55.8437 37.9144 51.8721 37.9144 51.8721L36.4733 48.9897L36.2645 47.0985C36.2645 46.8631 44.8906 44.2298 44.8906 36.5452C44.8906 27.3948 47.3324 20.4304 52.472 18.9307Z",
    fill: "#26335B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9144 51.8721L36.4733 48.9897L36.2645 47.0985L31.5547 58.1665H41.1387L37.9144 51.8721Z",
    fill: "#26335B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9327 18.0156H75.12L72.5296 23.5497H59.5778L61.9327 18.0156Z",
    fill: "#26335B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4584 29.2014H70.4102L67.8199 34.7355H54.868L57.4584 29.2014Z",
    fill: "#26335B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1387 58.1665C39.4147 54.7181 36.4733 48.9897 36.4733 48.9897M41.1387 58.1665C39.9775 55.8437 37.9144 51.8721 37.9144 51.8721M41.1387 58.1665C45.028 49.0514 46.9615 43.5959 50.8638 34.4863C53.6199 28.0528 57.9294 18.0156 57.9294 18.0156C57.9294 18.0156 54.397 18.369 52.472 18.9307C47.3324 20.4304 44.8906 27.3948 44.8906 36.5452C44.8906 44.2298 36.2645 46.8631 36.2645 47.0985M41.1387 58.1665H31.5547L36.2645 47.0985M41.1387 58.1665L37.9144 51.8721M36.4733 48.9897L36.2645 47.0985M36.4733 48.9897L37.9144 51.8721M61.9327 18.0156H75.12L72.5296 23.5497H59.5778L61.9327 18.0156ZM57.4584 29.2014H70.4102L67.8199 34.7355H54.868L57.4584 29.2014Z",
    stroke: "#26335B",
    strokeWidth: 1.88391
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.6751,
    cy: 27.0814,
    r: 7.30014,
    fill: "#0075FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVistaFlexLogoMark);
export default __webpack_public_path__ + "static/media/VistaFlexLogoMark.f0dfa0258a232923824e466e5e7346bc.svg";
export { ForwardRef as ReactComponent };